<!-- 登录 -->
<template>
    <div id="background">
        <div class="container">
            <form action="">
                <h1>登录</h1>
                <div class="form">
                    <!-- 账号 -->
                    <div class="item">
                        <label>手机号：</label>
                        <input type="text" name="phonenum" v-model.trim="phonenum" />
                        <br />
                    </div>
                    <!-- 密码 -->
                    <div class="item">
                        <label>密码：</label>
                        <input type="password" name="password" v-model.trim="password" autocomplete="password" />
                        <br />
                    </div>
                    <!-- 记住密码 -->
                    <div class="keep">
                        <div style="display: flex; align-items: center; margin-left: 308px; margin-top: 10px">
                            <input @click="savepwd()" id="yes" type="checkbox" v-model="pwdsave" />
                            <label for="yes">记住密码</label>
                        </div>
                    </div>
                </div>
            </form>
            <button type="submit" @click.prevent="handlelogin()">登录</button>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import Bus from "@/router/bus";
    import { SseService } from "@/utils/sseService.ts";
    import axios from "axios";
    import { mapActions } from "vuex";
    export default {
        data() {
            return {
                sanme: localStorage.nickName,
                isKeptLoggedIn: localStorage.s === "true",
                sa: localStorage.sa,

                // 不保存密码
                pwdsave: localStorage.pwdsave,
                phonenum: localStorage.tel,
                password: localStorage.pwd,

                respon: null,
                showPonent: false,
            };
        },
        // 不记住密码
        beforeCreate() {
            if (localStorage.pwdsave === false || localStorage.pwdsave === "false") {
                localStorage.pwd = "";
            }
        },
        created() {},
        methods: {
            savepwd() {
                this.pwdsave = !this.pwdsave;
                localStorage.setItem("pwdsave", this.pwdsave);
            },
            ...mapActions("auth", ["updateLoginData"]),
            handlelogin(phonenum = this.phonenum, password = this.password) {
                var p = phonenum;
                var m = password;
                this.handlesave();
                const url = `/api/user/login`;
                if (p === "") {
                    //名字为空
                    alert("用户名为空");
                    return;
                } else if (m === "") {
                    //密码为空
                    alert("密码为空");
                    return;
                } else {
                    axios
                        .post(
                            url,
                            {},
                            {
                                params: {
                                    phone: p,
                                    password: m,
                                },
                            }
                        )
                        .then((response) => {
                            this.respon = response.data;

                            if (this.respon.success && this.respon.success === true) {
                                // 提交登录信息到 vuex
                                this.updateLoginData(this.respon.data);

                                // 提交到本地存储
                                localStorage.authRoleVOList = JSON.stringify(this.respon.data.authRoleVOList);
                                localStorage.tokenName = this.respon.data.tokenName;
                                localStorage.nickname = this.respon.data.nickName;
                                localStorage.tel = p;
                                localStorage.loginId = this.respon.data.saTokenInfo.loginId;

                                //显示headercomponent
                                Bus.emit("changeMsg", true);

                                if (localStorage.pwdsave) {
                                    localStorage.pwd = this.password;
                                } else {
                                    localStorage.pwd = "";
                                }
                                localStorage.setItem("sa", "zhenzhi " + this.respon.data.saTokenInfo.tokenValue);

                                //如果输入的名字以及密码正确,路由跳转至
                                // 审核页面
                                this.$router.replace("/autopricecheck");
                                const sseService = new SseService();
                                sseService.connect();

                                return;
                            } else {
                                alert(this.respon.data);
                            }
                        })
                        .catch((error) => {
                            this.data = error;
                        });
                }
            },
            // 保持登录状态
            handlesave: function () {
                localStorage.s = "true";
            },
        },
    };
</script>

<style scoped>
    #background {
        width: 100%;
        height: 100%;
        background: url("@/assets/images/bg2.jpg");
        background-size: 100% 100%;
        position: fixed;
        top: 0;
        left: 0;
    }

    .container {
        width: 480px;
        height: 300px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #00000090;
        text-align: center;
        border-radius: 20px;
        margin-top: 10px;
    }

    .container h1 {
        color: aliceblue;
        margin-left: 20px;
    }

    .item {
        color: white;
        margin-left: 15%;
        margin-top: 35px;
        font-size: 20px;
        text-align: left;
    }

    .item label {
        float: left;
        width: 5em;
        margin-right: 1em;
        text-align: right;
    }

    input {
        margin-left: -5px;
        padding: 4px;
        border: solid 1px #4e5ef3;
        outline: 0;
        font: normal 23px/100% Verdana, Tahoma, sans-serif;
        width: 200px;
        height: 30px;
        background: #f1f1f190;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px;
    }

    button {
        position: relative;
        height: 33px;
        width: 100px;
        background: rgba(35, 19, 252, 0.425);
        border-radius: 10px;
        margin-top: 18px;
        box-shadow: none;
        color: white;
        margin-left: 40px;
        margin-right: 10px;
    }

    #yes {
        margin: 2px;
    }

    .keep {
        color: white;
    }

    .keep input {
        width: 15px;
        height: 15px;
        margin-top: 7px;
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
